import { render, staticRenderFns } from "./ProductCheckView.vue?vue&type=template&id=345d1a3b&scoped=true&"
import script from "./ProductCheckView.vue?vue&type=script&lang=js&"
export * from "./ProductCheckView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345d1a3b",
  null
  
)

export default component.exports